import React from 'react';
import { Link } from 'react-router-dom';

const LEAD_CONTEXT_KEY = 'lead_context_v1';

const CaseStudies = () => {
    const studies = [
        {
            id: 1,
            icon: "fas fa-university",
            industry: "Finance",
            type: "Fraud Detection",
            title: "AI-Powered Fraud Prevention",
            description: "Real-time anomaly detection engine for a Tier-1 South African bank.",
            metrics: [
                { label: "Fraud Reduction", value: "87%" },
                { label: "Annual Savings", value: "R120M+" }
            ],
            techStack: ["Python", "TensorFlow"]
        },
        {
            id: 2,
            icon: "fas fa-tractor",
            industry: "Agriculture",
            type: "Computer Vision",
            title: "Crop Yield Optimization",
            description: "Edge-computing models to analyze crop health in real-time.",
            metrics: [
                { label: "Yield Increase", value: "22%" },
                { label: "Water Usage", value: "-30%" }
            ],
            techStack: ["PyTorch", "Azure IoT"]
        },
        {
            id: 3,
            icon: "fas fa-hospital-user",
            industry: "Healthcare",
            type: "NLP",
            title: "Automated Patient Triage",
            description: "NLP system to categorize and prioritize patient queries.",
            metrics: [
                { label: "Response Time", value: "< 2s" },
                { label: "Hours Saved", value: "400/mo" }
            ],
            techStack: ["BERT", "FastAPI"]
        }
    ];

    const setLeadContext = (ctx) => {
        try { window.localStorage.setItem(LEAD_CONTEXT_KEY, JSON.stringify(ctx)); } catch { /* no-op */ }
    };

    return (
        <section className="case-studies" id="case-studies">
            <div className="container">
                <div className="section-header fade-in">
                    <p className="eyebrow">Proven Impact</p>
                    <h2>Enterprise AI outcomes with numbers attached.</h2>
                    <p>Representative engagements across regulated, operationally complex sectors.</p>
                </div>

                <div className="case-grid">
                    {studies.map((study) => (
                        <div key={study.id} className="case-card fade-in">
                            <div className="case-header">
                                <div className="case-icon">
                                    <i className={study.icon} aria-hidden="true"></i>
                                </div>
                                <div className="case-tags">
                                    <span>{study.industry}</span>
                                    <span>{study.type}</span>
                                </div>
                            </div>
                            
                            <div className="case-content">
                                <h3>{study.title}</h3>
                                <p>{study.description}</p>
                                
                                <div className="case-metrics">
                                    {study.metrics.map((metric, index) => (
                                        <div key={index} className="metric-item">
                                            <span className="metric-value">{metric.value}</span>
                                            <span className="metric-label">{metric.label}</span>
                                        </div>
                                    ))}
                                </div>

                                <div className="tech-stack" aria-label="Technology stack">
                                    {study.techStack.map((tech) => (
                                        <span key={tech}>{tech}</span>
                                    ))}
                                </div>

                                <Link
                                    className="case-link"
                                    to="/contact"
                                    onClick={() =>
                                        setLeadContext({
                                            message: `Interested in a solution similar to: "${study.title}".`
                                        })
                                    }
                                >
                                    Request technical brief <i className="fas fa-arrow-right" aria-hidden="true"></i>
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default CaseStudies;
